import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import './Countdown.css'
import moment from 'moment'

class AnimatedCard extends React.Component {
	render() {
		const { position, digit, animation, primaryColor } = this.props;
		return(
			<div className={`flipCard ${position} ${animation}`} style={{backgroundColor:`${primaryColor}`}}>
				<span>{digit}</span>
			</div>
		);
	}
}

class StaticCard extends React.Component {
	render() {
		const { position, digit } = this.props;
		return(
			<div className={position}>
				<span>{digit}</span>
			</div>
		);
	}
}

class FlipUnitContainer extends PureComponent {
  
  constructor(props){
    super(props)

    this.state = {
      unit : props.unit,
      digit: props.digit,
      previousDigit: props.digit,
      shuffle: false
    }
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.digit !== this.props.digit){
      this.setState({
        digit: nextProps.digit,
        previousDigit: this.props.digit,
        shuffle: !this.state.shuffle
      })
    }
  }

  componentWillUnmount(){
    if (this._timeout) clearTimeout(this._timeout)
  }

	render() {
    const { digit, previousDigit, shuffle, unit } = this.state
		const {primaryColor} = this.props
		let now = previousDigit
    let before = digit
     
		// shuffle digits
		const digit1 = shuffle ?  now : before;
		const digit2 = !shuffle ? now : before ;
		
		// shuffle animations
		const animation1 = shuffle ? 'fold' : 'unfold';
		const animation2 = !shuffle ? 'fold' : 'unfold';
		
		return(
			<div className={'flipUnitContainer'} style={{fontSize:'14px', background:`${primaryColor}`}}>
				<StaticCard 
					position={'upperCard'} 
					digit={before} 
					/>
				<StaticCard 
					position={'lowerCard'} 
					digit={now} 
					/>
        <AnimatedCard 
          primaryColor={primaryColor}
					position={'first'}
					digit={digit1}
					animation={animation1}
					/>
        <AnimatedCard 
          primaryColor={primaryColor}
					position={'second'}
					digit={digit2}
					animation={animation2}
					/>
          <div className="unit-countdown">{unit}</div>
			</div>
		);
	}
}



function addLeadingZeros(value) {
  value = String(value);
  
  while (value.length < 2) {
    value = '0' + value;
  }
  return value;
}


export class Countdown extends Component {

  componentDidMount() {
    this._isMounted = true
    // update every second
    this.interval = setInterval(() => {
      if (!this._isMounted) return // Block unmounted component
      this.forceUpdate() // refresh every second
    }, 1000);
  }

  componentWillUnmount() {
    this._isMounted = false
    this.stop();
  }

  stop() {
    clearInterval(this.interval);
  }

  calculateCountdown(date) {
    const endDate = new Date(date).getTime() // en ms
    const now = new Date().getTime()
    const duration = moment.duration(Math.max(0, endDate - now), 'milliseconds')
    
    const timeLeft = {
      years: duration.years(),
      days: duration.days(),
      hours: duration.hours(),
      min: duration.minutes(),
      sec: duration.seconds()
    };
    return timeLeft;
  }

  render() {
    const countDown = this.calculateCountdown(this.props.date)
    const {primaryColor} = this.props
    return (
      <div className={'flipClock'}>
        <FlipUnitContainer digit={addLeadingZeros(countDown.days)} primaryColor={primaryColor} unit="Jours"/>
        <FlipUnitContainer digit={addLeadingZeros(countDown.hours)} primaryColor={primaryColor} unit="Heures"/>
        <FlipUnitContainer digit={addLeadingZeros(countDown.min)} primaryColor={primaryColor} unit="Minutes"/>
        <FlipUnitContainer digit={addLeadingZeros(countDown.sec)} primaryColor={primaryColor} unit="Secondes"/>
      </div>
    );
  }
}

Countdown.propTypes = {
  date: PropTypes.string.isRequired
};

Countdown.defaultProps = {
  date: new Date()
};



// WEBPACK FOOTER //
// ./src/components/Clocks/Countdown/index.js